/**
 * RFC 9457 problem+json, with the required extensions of API_CONTRACT.md §8.1.
 *
 * TASK-01 defines the SHAPE only. The full 78-code catalogue and its
 * machine-readable `errors.json` are TASK-06 (SETUP-003/004, DB-007).
 */
import { z } from 'zod';
export const PROBLEM_CONTENT_TYPE = 'application/problem+json';
/** Per-field validation detail (API_CONTRACT.md §8.1 `errors[]`). */
export const problemFieldErrorSchema = z.object({
    field: z.string(),
    code: z.string(),
    message: z.string(),
});
export const problemSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int().min(100).max(599),
    detail: z.string().optional(),
    instance: z.string().optional(),
    // Required extensions — API_CONTRACT.md §8.1
    code: z.string(),
    correlation_id: z.string(),
    retryable: z.boolean(),
    user_message: z.string().optional(),
    remediation: z.record(z.unknown()).optional(),
    errors: z.array(problemFieldErrorSchema).optional(),
    meta: z.record(z.unknown()).optional(),
});
/**
 * Foundation error codes only — the subset TASK-01 can raise before the
 * catalogue exists. Namespaces are those of API_CONTRACT.md §8.3.
 */
export const FOUNDATION_ERROR_CODES = {
    VALIDATION_FAILED: 'validation.failed',
    VALIDATION_UNKNOWN_FIELD: 'validation.unknown_field',
    RESOURCE_NOT_FOUND: 'resource.not_found',
    AUTH_UNAUTHENTICATED: 'auth.unauthenticated',
    AUTH_CAPABILITY_REQUIRED: 'auth.capability_required',
    SERVER_INTERNAL_ERROR: 'server.internal_error',
};
//# sourceMappingURL=problem.js.map